export default "__VITE_ASSET__1caa4264__"